import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { List, ListItemIcon, ListItemText } from '@mui/material';
import StyledNavListItem from './StyledNavListItem';

const PortalNavList = ({ items, onNavigate }) => {
  const location = useLocation();
  const isPathActive = (path) => location.pathname.startsWith(path);

  return (
    <List disablePadding>
      {items.map(({ label, path, icon: Icon }) => (
        <StyledNavListItem
          key={path}
          button
          component={Link}
          to={path}
          isActive={isPathActive(path)}
          onClick={onNavigate}
        >
          <ListItemIcon>
            <Icon />
          </ListItemIcon>
          <ListItemText primary={label} />
        </StyledNavListItem>
      ))}
    </List>
  );
};

export default PortalNavList;
